import React from 'react';
import Button from './Button';

const Dialog = ({
  isOpen,
  onClose,
  title,
  messages = [],
  buttons = [],
  className = ''
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="fixed inset-0 bg-black bg-opacity-70 transition-opacity"
        onClick={onClose}
      />
      <div className={`relative z-50 w-full max-w-md bg-gray-weak border border-gray-more rounded-lg shadow-xl p-6 ${className}`}>
        {title && (
          <h3 className="text-lg font-medium text-gray-strongest">
            {title}
          </h3>
        )}

        {messages.map((message, index) => (
          <p key={index} className="mt-2 text-sm text-gray-strong">
            {message}
          </p>
        ))}

        {buttons.length > 0 && (
          <div className="mt-4 flex justify-end gap-3">
            {buttons.map((button, index) => (
              <Button
                key={index}
                onClick={() => {
                  button.onClick?.();
                  if (button.closeOnClick !== false) {
                    onClose();
                  }
                }}
                className={button.className}
                disabled={button.disabled}
                isLoading={button.isLoading}
                loadingText={button.loadingText}
              >
                {button.label}
              </Button>
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

export default Dialog;
